import { AuthMethodsType } from "components/molecules/LoginForm";
import classNames from "classnames";

import "./styles.sass";

interface IProps {
  options: Array<{ id: AuthMethodsType; label: string }>;
  selectedMethod: string;
  setSelectedMethod: (method: AuthMethodsType) => void;
}

const AuthSelector = ({
  options,
  selectedMethod = "email",
  setSelectedMethod,
}: IProps) => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const containerClass = classNames({
    // eslint-disable-next-line camelcase
    AuthSelector__container: VITE_APP_PROJECT_NAME === "glory",
    // eslint-disable-next-line camelcase
    AuthSelector__container__banger: VITE_APP_PROJECT_NAME === "banger",
  });

  const buttonActiveClass = classNames({
    // eslint-disable-next-line camelcase
    "AuthSelector__button--active": VITE_APP_PROJECT_NAME === "glory",
    // eslint-disable-next-line camelcase
    "AuthSelector__button--active__banger": VITE_APP_PROJECT_NAME === "banger",
  });

  const buttonSliderActiveClass = classNames({
    // eslint-disable-next-line camelcase
    AuthSelector__slider: VITE_APP_PROJECT_NAME === "glory",
    // eslint-disable-next-line camelcase
    AuthSelector__slider__banger: VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <div className={containerClass}>
      <div
        className={`${buttonSliderActiveClass} AuthSelector__slider--${selectedMethod}`}
      />

      {/* eslint-disable-next-line react/no-unused-prop-types */}
      {options.map(({ id, label }: { id: AuthMethodsType; label: string }) => (
        <div
          key={id}
          onClick={() => setSelectedMethod(id)}
          className={`AuthSelector__button ${
            selectedMethod === id
              ? buttonActiveClass
              : "AuthSelector__button--inactive"
          }`}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default AuthSelector;
